<template>
<div style="height: 100%;overflow: hidden">
  <div class="title fixed">今日计分</div>
  <div class="score-operation-box fixed">
      <el-carousel type="card" height="200px" arrow="never" :autoplay="false" @change="handleCarouselChange">
        <el-carousel-item>
          <div class="score-btn plus" :scale="currentCarouselIdx!==0" @click="showScoreDialog('plus')">
            <div class="backcolor wave plus"></div>
            <div class="text-info">
              <div class="score-count">
                <span class="desc">今日总计</span>
                <span class="score plus">{{`+${positiveScoreSum}`}}</span>
                <span class="unit">分</span>
              </div>
              <div class="score plus">点击+1</div>

            </div>
          </div>

        </el-carousel-item>
        <el-carousel-item>
          <div class="score-btn minus" :scale="currentCarouselIdx!==1" @click="showScoreDialog('minus')">
            <div class="backcolor wave minus"></div>
            <div class="text-info">
              <div class="score-count">
                <span class="desc">今日总计</span>
                <span class="score minus">{{`-${-negativeScoreSum}`}}</span>
                <span class="unit">分</span>
              </div>
              <div class="score minus">点击-1</div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
  </div>
  <div class="holder"></div>
  <div class="score-detail-box">
    <div v-for="(item,idx) in recordData" :key="idx" class="score-item">
      <div class="score" :type="item.score>0?'plus':'minus'">
        {{`${item.score>0?'+':''}${item.score}`}}
      </div>
      <div class="detail">

        <div><el-tag size="mini" :type="item.score>0?'':'danger'">{{item.reason}}</el-tag></div>
        <div class="time">
          <span>{{formatDateTime(formatDateStrFromUTC(item.create_time))}}</span>
          <span class="ago">{{timeAgo(formatDateStrFromUTC(item.create_time))}}</span>
        </div>
      </div>
    </div>
  </div>

  <el-dialog :visible.sync="dialogVisible" :show-close="false" width="80%">
    <AddScoreRecord  v-if="dialogVisible" :score-type="currentScoreType" style="margin-top: -25px" @added="handleScoreAdded"></AddScoreRecord>

  </el-dialog>
</div>
</template>

<script>
import {getScoreByDay} from "@/api/api";
import AddScoreRecord from "@/components/AddScoreRecord";
import {formatDateTime,timeAgo,formatDate,formatDateStrFromUTC} from "@/util/time";

// const mockData={}
export default {
  name: "CurrentDay",
  components: {AddScoreRecord},
  props:[{
    name:"fd",
  }],
  data(){
    return {
      recordData:[],
      dialogVisible:false,
      currentScoreType:'plus',
      currentCarouselIdx:0,
    }
  },
  computed:{
    positiveScoreSum(){
      return this.recordData.reduce((t,c)=>t+(c.score>0?c.score:0),0)
    },
    negativeScoreSum(){
      return this.recordData.reduce((t,c)=>t+(c.score<0?c.score:0),0)
    }
  },
  mounted() {
    this.getScoreOfDay()
  },
  methods:{
    formatDateTime,timeAgo,formatDateStrFromUTC,
    getScoreOfDay(){
      getScoreByDay({date:formatDate(new Date())}).then(res=>{
        console.log(res)
        this.recordData=res.data.reverse()
      }).catch(err=>{
        console.log(err)
      })
    },
    showScoreDialog(type){
      if(type===this.currentScoreType){
        this.dialogVisible=true
      }
      this.currentScoreType=type;
    },
    handleCarouselChange(idx){
      this.currentCarouselIdx=idx
    },
    handleScoreAdded(){
      this.getScoreOfDay()
      this.dialogVisible=false
    }
  }
}
</script>

<style lang="scss" scoped>
.fixed{
  position: fixed;
  width: 100%;
}
.title{
  top:0;
  height: 60px;
  font-size: 26px;
  line-height: 60px;
}
.score-operation-box{
  top:70px;
  .score-btn{
    height: 180px;
    width: 180px;
    border-radius: 50%;
    position: relative;
    overflow: hidden;
    &.plus{
      border: 1px solid #42b98399;
    }
    &.minus{
      border: 1px solid #F56C6C99;
    }
    .backcolor{
      z-index: -1;
    }
    .text-info{
      position: absolute;
      width: 140px;
      height: 140px;
      left: calc(50% - 70px);
      top: calc(50% - 70px);
      .score{
        font-size: 14px;
        margin-top: 20px;
        &.plus{
          color: #268756;
        }
        &.minus{
          color: #d22d2d;
        }
      }
      .score-count{
        display: flex;
        align-items: flex-end;
        justify-content: center;
        margin-top: 5px;
        .desc{
          font-size: 10px;
          margin: 0 2px;
          color: #777777;
          width: 20px;
        }
        .score{
          font-size: 48px;
          margin-bottom: -14px;
          &.plus{
            color: #268756;
          }
          &.minus{
            color: #d22d2d;
          }
        }
        .unit{
          font-size: 20px;
          color: #888888;
        }
      }
    }
  }
}
.holder{
  display: block;
  height: 300px;
}
.score-detail-box{
  overflow: scroll;
  height: calc(100vh - 300px);
  .score-item{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 15px;
    &:last-child{

      margin-bottom: 60px;
    }
    .score{
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      &[type=plus]{
        background: #42b98399;
        color: #42b983;
      }
      &[type=minus]{
        background: rgb(250 158 158);
        color: #d22d2d;
      }
    }
    .detail{
      margin-left: 15px;
      width: 200px;
      //flex-grow: 1;
      text-align: left;
      .time{
        margin-top: 5px;
        color: #666;
        font-size: 12px;
        .ago{
          margin-left: 20px;
          color: #999;
          font-style: italic;
        }
      }
    }
  }
}
.score-btn{
  transition: all 0.3s;
  &[scale=true]{
    scale: 0.7;
  }
  .wave {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    /* background-color: rgb(255, 115, 145); */
    &.plus{
      background-color: #89d1ad;
    }
    &.minus{
      background-color: rgb(250 158 158);
    }
  }
  .wave:before,
  .wave:after{
    content: "";
    position: absolute;
    width: 400px;
    height: 400px;
    /* top: -80px; */
    top: -40px;
    left: 50%;
    background-color: rgba(255, 255, 255, .4);
    border-radius: 45%;
    transform: translate(-50%, -70%) rotate(0);
    animation: rotate 5s linear infinite;
    z-index: 10;
  }

  .wave:after {
    border-radius: 47%;

    background-color: rgba(255, 255, 255, .9);
    transform: translate(-50%, -70%) rotate(90deg);
    animation: rotate1 5s linear   infinite;
    z-index: 20;
  }

  @keyframes rotate {
    0% {
      transform: translate(-50%, -73%) rotate(0deg);
      //top:0px;

    }
    50% {
      transform: translate(-50%, -73%) rotate(180deg);
      //top: -40;

    } 100% {
        transform: translate(-50%, -73%) rotate(360deg);
        //top: -80px;
      }
  }
  @keyframes rotate1 {
    0% {
      transform: translate(-50%, -73%) rotate(0deg);
      //top:0px;

    }
    50% {
      transform: translate(-50%, -73%) rotate(90deg);
      //top:-40px;

    } 100% {
        transform: translate(-50%, -73%) rotate(270deg);
        //top: -80px;
      }
  }
}

</style>